import { Component } from "@angular/core";

@Component({
  selector: "app-input-error",
  standalone: true,
  templateUrl: "./input-error.component.html",
  styleUrl: "./input-error.component.scss"
})
export class InputErrorComponent { }
